import styles from "./index.module.scss"
import RcmpLoading from "../../atoms/Loading"
import RcmpModalAlert from "../ModalAlert"
import RcmpButton from "../../atoms/Button"
import InfoCircleIcon from "../../../assets_v2/icons/InfoCircleIcon"
import { useContext } from "react"
import { ColorsContext } from "../../../contexts/Colors"

export default function RcmpModalInfo(props) {
  const {
    fnHandleCancel,
    bIsOpen,
    title,
    buttonCancelText,
    buttonSaveText,
    description,
    fnHandleConfirm,
    size,
    onlyText = false,
    oResponse,
    oButtonCancelProps,
    oButtonSaveProps,
    subText,
    icon,
    bgIconColor,
    bgButtonColor,
    bHasConfirmButton = false,
    bNotShowLoadingContainer = false,
    children,
    bgButtonConfirmColor,
    ...oRest
  } = props

  const oButtonCancelPropsFormated = {
    ...oButtonCancelProps,
    style: {
      ...(oButtonCancelProps?.style || {}),
      display: oResponse?.loading
        ? "none"
        : oButtonCancelProps?.style?.display || "block",
    },
  }

  const {oCurrentDepartamentColors} = useContext(ColorsContext) ?? {}
  const oButtonSavePropsFormated = {
    ...oButtonSaveProps,
    style: {
      ...(oButtonSaveProps?.style || {}),
      display: oResponse?.loading ? "none" : oButtonSaveProps?.style?.display || "block",
    },
  }

  return (

    <RcmpModalAlert
      isOpen={bIsOpen}
      icon={icon ? icon : <InfoCircleIcon stroke={oCurrentDepartamentColors?.opc_cprimary_color} />
      }
      color={oCurrentDepartamentColors?.opc_csecondary_color || "#EBF3FF"}
      fnOnClose={() => fnHandleCancel(true)}
      {...oRest}
    >
      <div className={styles.modalInfoContent}>
        {(oResponse?.loading && !bNotShowLoadingContainer) ? (
          <RcmpLoading className={styles.modalInfoLoading} bShow={true} />
        ) : (
          <>
            <div className={styles.textContainer}>
              <h3 className={styles.titleStyle}>{title}</h3>
              <p className={!title ? styles.titleTextStyle : styles.descriptionStyle}>{description}</p>
              <p className={styles.subTextStyle}>{subText}</p>
            </div>
          </>
        )}
      </div>
      {children}
      {(!oResponse?.loading || bNotShowLoadingContainer) && <div className={!bHasConfirmButton ? styles.modalInfoFooter : styles.modalInfoFooterWithConfirmButton}>
        <RcmpButton
          filled={false}
          color="system"
          onClick={bHasConfirmButton ? () => fnHandleCancel(true) : (e) => { e.preventDefault(); e.stopPropagation(); fnHandleConfirm(e)}}
          type="button"
          className={styles.cancelButton}
          disabled={oResponse?.loading}
          style={{backgroundColor: bgButtonConfirmColor, color: !bgButtonConfirmColor ? "" : "#ffffff"}}
        >
          {buttonCancelText}
        </RcmpButton>
      {bHasConfirmButton && (
          <RcmpButton
            filled={true}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); fnHandleConfirm(e)}}
            type="button"
            style={{ backgroundColor: bgButtonColor }}
            className={styles.saveButton}
            isLoading={oResponse?.loading}
            disabled={oResponse?.loading}
          >
            {buttonSaveText}
          </RcmpButton>
      )  
      }
      </div>}
    </RcmpModalAlert>
  )
}
